<template>
  <div ref="SearchDemos">
    <Navbar />

    <div id="main">
      <div class="container">
        <div class="row align-items-center text-center">
          <div class="col-md-12 px-0" v-lazy-container="{ selector: 'img' }">
            <img data-src="/logo/search_demo_pic002.jpg" data-loading="/logo/search_demo_pic002.jpg"
              style="width:100%;max-height:495px;object-fit:cover;">
            <h2 id="centered">Search Demos</h2>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row">
          <div id="detail" class="col-12" style="background: linear-gradient(#1b1b1b, #4e4e4e); color:#fff;">
            <form class="row" @submit.prevent="submitSearch">
              <div class="col-12">
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>First Name</label>
                    <div :class="{ 'control is-loading': processing }">
                      <input type="text" class="form-control" placeholder="First Name" v-model="name"
                        :disabled="processing">
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Last Name</label>
                    <div :class="{ 'control is-loading': processing }">
                      <input type="text" class="form-control" placeholder="Last Name" v-model="lastname"
                        :disabled="processing">
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Demo Category</label>
                    <div :class="{ 'control is-loading': processing }">
                      <multiselect ref="category_ref_id" v-model="category_ref_id" :options="categories"
                        placeholder="Category..." label="name_en" track-by="id" :multiple="true" :disabled="processing">
                      </multiselect>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Gender</label>
                    <div :class="{ 'control is-loading': processing }">
                      <multiselect ref="gender" v-model="gender" :options="gender_opt" placeholder="Gender..."
                        label="name" track-by="id" :multiple="true" :disabled="processing"></multiselect>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Age Range</label>
                    <div :class="{ 'control is-loading': processing }">
                      <multiselect ref="age_range_str" v-model="age_range_str" :options="age_range"
                        placeholder="Age Range..." label="name" track-by="id" :multiple="true" :disabled="processing">
                      </multiselect>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Country</label>
                    <div :class="{ 'control is-loading': processing }">
                      <multiselect ref="country_id" v-model="country_id" :options="countries" placeholder="Country..."
                        label="name" track-by="id" :multiple="true" :disabled="processing"></multiselect>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label>City</label>
                    <div :class="{ 'control is-loading': processing }">
                      <multiselect ref="city_str" v-model="city_str" :options="cities" placeholder="City..."
                        label="name" track-by="id" :multiple="true" :disabled="processing"></multiselect>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Ethnicity</label>
                    <div :class="{ 'control is-loading': processing }">
                      <multiselect ref="ethnicity_str" v-model="ethnicity_str" :options="ethnicities"
                        placeholder="Ethnicity..." label="name" track-by="id" :multiple="true" :disabled="processing">
                      </multiselect>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Union Status</label>
                    <div :class="{ 'control is-loading': processing }">
                      <multiselect ref="union_status_str" v-model="union_status_str" :options="union_status"
                        placeholder="Union Status..." label="name" track-by="id" :multiple="true"
                        :disabled="processing"></multiselect>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Language</label>
                    <div :class="{ 'control is-loading': processing }">
                      <multiselect ref="language_str" v-model="language_str" :options="languages"
                        placeholder="Language..." label="name" track-by="id" :multiple="true" :disabled="processing">
                      </multiselect>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 text-center my-4">
                <button type="submit" class="btn btn-idiom btn-round mx-2 px-3"
                  :class="{ 'button is-loading': processing }">Search</button>
                <!-- <button type="button" class="btn btn-idiom btn-round mx-2 px-3"
                  :class="{'button is-loading':processing}" @click="clearForm">Clear</button> -->
              </div>
            </form>

            <div class="row" v-if="display">
              <div class="col-12 my-4">
                Search
                Results<!-- <span class="btn-idiom btn-round py-1 px-2 ml-1">{{audio.length}} Results Found</span> -->
              </div>
              <div class="col-lg-3 col-md-4 col-xs-6 mb-5 px-2 text-center" v-for="(val, key) in filter_audio"
                :key="key">
                <img v-lazy="idiom + 'source/img/' + val.image_file" :alt="val.name + ' ' + val.lastname"
                  style="height:200px;width:100%;object-fit:cover;object-position:50% 0;">
                <div
                  style="background:linear-gradient(#7c7c7c,#000);width:100%;text-overflow: ellipsis;overflow: hidden; white-space: nowrap;">
                  <span class="font-white font-bold" style="width:100%;text-shadow: 1px 1px 5px black;">
                    {{ val.name + ' ' + val.lastname }} <i>{{ val.category_name }}</i>
                  </span>
                </div>
                <audio controls controlsList="nodownload" preload="none" style="width:100%;height:35px;">
                  <source :src="idiom + 'source/audio/' + val.file_name" type="audio/mp3" />
                </audio>
              </div>
            </div>

            <div class="col-12 text-center" v-if="processing && !full_search">
              <div class="spinner-border mx-2" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>

          </div>
        </div>
      </div>

      <Footer />
    </div>

  </div>

</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
import Multiselect from 'vue-multiselect'

export default {
  name: 'SearchDemos',
  components: { Navbar, Footer, Multiselect },
  data() {
    return {
      processing: false,
      full_search: false,
      last_filter: null,
      this_filter: null,
      audio: [],
      display: false,
      // .................
      name: "",
      lastname: "",
      category_ref_id: [],
      gender: [],
      age_range_str: [],
      country_id: [],
      city_str: [],
      ethnicity_str: [],
      union_status_str: [],
      language_str: [],
      // .................
      categories: [],
      cities: [],
      countries: [],
      ethnicities: [],
      age_range: [],
      languages: [],
      union_status: [
        { id: 1, name: 'Sag/Aftra' },
        { id: 2, name: 'Non-Union' },
        { id: 3, name: 'Fi-Core' },
        { id: 4, name: 'Eligible' },
        { id: 5, name: 'Must-Join' },
      ],
      gender_opt: [
        { id: 1, name: 'Male' },
        { id: 2, name: 'Female' },
        { id: 3, name: 'Non-Binary' }
      ]
    }
  },
  created() {
    this.audio = this.LocalStorage("_IdiomtalentAudio", new Array());

    this.categories = this.LocalStorage("_IdiomtalentDataCategories", new Array());
    this.cities = this.LocalStorage("_IdiomtalentDataCities", new Array());
    this.countries = this.LocalStorage("_IdiomtalentDataCountries", new Array());
    this.ethnicities = this.LocalStorage("_IdiomtalentDataEthnicities", new Array());
    this.age_range = this.LocalStorage("_IdiomtalentDataAgeRange", new Array());
    this.languages = this.LocalStorage("_IdiomtalentDataLanguages", new Array());

    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  mounted() {
    if (!this.categories.length) this.get_categories();
    if (!this.cities.length) this.get_cities();
    if (!this.countries.length) this.get_countries();
    if (!this.ethnicities.length) this.get_ethnicities();
    if (!this.age_range.length) this.get_age_range();
    if (!this.languages.length) this.get_languages();
  },
  methods: {
    async get_categories() {
      var url = this.api + 'dataOption/get_categories/' + this.secret;
      var data = new FormData();
      data.set('secret', this.secret);
      await this.Axios.post(url, data)
        .then((response) => {
          if (response.data.error == 0) {
            this.categories = response.data.data;
            localStorage.setItem("_IdiomtalentDataCategories", JSON.stringify(response.data.data));
          }
        })
        .catch((error) => {
          alert(error);
          console.error(error);
        })
    },
    async get_cities() {
      var url = this.api + 'dataOption/get_cities/' + this.secret;
      var data = new FormData();
      data.set('secret', this.secret);
      await this.Axios.post(url, data)
        .then((response) => {
          if (response.data.error == 0) {
            this.cities = response.data.data;
            localStorage.setItem("_IdiomtalentDataCities", JSON.stringify(response.data.data));
          }
        })
        .catch((error) => {
          alert(error);
          console.error(error);
        })
    },
    async get_countries() {
      var url = this.api + 'dataOption/get_countries/' + this.secret;
      var data = new FormData();
      data.set('secret', this.secret);
      await this.Axios.post(url, data)
        .then((response) => {
          if (response.data.error == 0) {
            this.countries = response.data.data;
            localStorage.setItem("_IdiomtalentDataCountries", JSON.stringify(response.data.data));
          }
        })
        .catch((error) => {
          alert(error);
          console.error(error);
        })
    },
    async get_ethnicities() {
      var url = this.api + 'dataOption/get_ethnicities/' + this.secret;
      var data = new FormData();
      data.set('secret', this.secret);
      await this.Axios.post(url, data)
        .then((response) => {
          if (response.data.error == 0) {
            this.ethnicities = response.data.data;
            localStorage.setItem("_IdiomtalentDataEthnicities", JSON.stringify(response.data.data));
          }
        })
        .catch((error) => {
          alert(error);
          console.error(error);
        })
    },
    async get_age_range() {
      var url = this.api + 'dataOption/get_age_range/' + this.secret;
      var data = new FormData();
      data.set('secret', this.secret);
      await this.Axios.post(url, data)
        .then((response) => {
          if (response.data.error == 0) {
            this.age_range = response.data.data;
            localStorage.setItem("_IdiomtalentDataAgeRange", JSON.stringify(response.data.data));
          }
        })
        .catch((error) => {
          alert(error);
          console.error(error);
        })
    },
    async get_languages() {
      var url = this.api + 'dataOption/get_languages/' + this.secret;
      var data = new FormData();
      data.set('secret', this.secret);
      await this.Axios.post(url, data)
        .then((response) => {
          if (response.data.error == 0) {
            this.languages = response.data.data;
            localStorage.setItem("_IdiomtalentDataLanguages", JSON.stringify(response.data.data));
          }
        })
        .catch((error) => {
          alert(error);
          console.error(error);
        })
    },
    async processFormAddDemo() {
      if (this.uploading) return false;

      this.uploading = true;
      var url = this.api + 'MediaFile/upload_demo/' + this.secret;
      let data = new FormData();
      data.append('file', this.$refs.file.files[0]);
      data.set('id', 0);
      await this.Axios.post(url, data)
        .then((response) => {
          console.log(response.data);
          if (response.data.error == 0) {
            this.demo_files.push(response.data.audio);
            this.showAddDemo = false;
          }
        })
        .catch((error) => {
          alert(error);
          console.error(error);
        })
        .then(() => {
          this.uploading = false;
        })
    },
    submitSearch() {
      this.processing = true;
      this.this_filter = JSON.stringify({
        name: this.name.trim(),
        lastname: this.lastname.trim(),
        category_ref_id: this.category_ref_id.map((e) => e.id),
        gender: this.gender.map((e) => e.id),
        age_range_str: this.age_range_str.map((e) => e.name),
        country_id: this.country_id.map((e) => e.id),
        city_str: this.city_str.map((e) => e.name),
        ethnicity_str: this.ethnicity_str.map((e) => e.name),
        union_status_str: this.union_status_str.map((e) => e.name),
        language_str: this.language_str.map((e) => e.name),
      });
      if (this.this_filter !== this.last_filter) {
        this.last_filter = this.this_filter;
        this.full_search = false;
      }
      if (!this.full_search) {
        this.get_audio_list();
      } else {
        this.processing = false;
      }
    },
    clearForm() {
      console.log("clearForm")
    },
    async get_audio_list() {
      var url = this.api + 'audio/get_audio_list/' + this.secret;
      var data = new FormData();
      let ignore = this.audio.map(e => e.id);
      if (ignore.length) {
        data.set('ignore', JSON.stringify(ignore));
      }
      if (this.name.trim() !== "") {
        data.set('name', this.name);
      }
      if (this.lastname.trim() !== "") {
        data.set('lastname', this.lastname);
      }
      if (this.category_ref_id.length) {
        data.set('category_ref_id', JSON.stringify(this.category_ref_id.map((e) => e.id)));
      }
      if (this.gender.length) {
        // data.set('gender',JSON.stringify(this.gender) );
        data.set('gender', JSON.stringify(this.gender.map((e) => e.id)));
      }
      if (this.age_range_str.length) {
        data.set('age_range_str', JSON.stringify(this.age_range_str.map((e) => e.name)));
      }
      if (this.country_id.length) {
        data.set('country_id', JSON.stringify(this.country_id.map((e) => e.id)));
      }
      if (this.city_str.length) {
        data.set('city_str', JSON.stringify(this.city_str.map((e) => e.name)));
      }
      if (this.ethnicity_str.length) {
        data.set('ethnicity_str', JSON.stringify(this.ethnicity_str.map((e) => e.name)));
      }
      if (this.union_status_str.length) {
        data.set('union_status_str', JSON.stringify(this.union_status_str.map((e) => e.name)));
      }
      if (this.language_str.length) {
        data.set('language_str', JSON.stringify(this.language_str.map((e) => e.name)));
      }
      data.set('secret', this.secret);
      await this.Axios.post(url, data)
        .then((response) => {
          if (response.data.error == 0) {
            this.last_filter = this.this_filter;
            this.this_filter = null;
            response.data.data.forEach((e) => {
              let findIndex = this.audio.findIndex(x => x.id == e.id);
              if (findIndex == -1) this.audio.push(e);
            });
            localStorage.setItem("_IdiomtalentAudio", JSON.stringify(this.audio));
          } else {
            this.full_search = true;
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .then(() => {
          this.processing = false;
          this.display = true;
        })
    },
    handleScroll(e) {
      let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight === document.documentElement.offsetHeight

      if (bottomOfWindow) {
        console.log("scrollDonwLoadMore..", e);
        if (this.display) this.submitSearch();
      }
    }
  },
  computed: {
    filter_audio() {
      return this.audio.filter(audio => {
        const searchName = audio.name.toLowerCase().includes(this.name.trim().toLowerCase());
        const searchLastname = audio.lastname.toLowerCase().includes(this.lastname.trim().toLowerCase());
        const searchCategory = (this.category_ref_id.length) ? this.category_ref_id.some(e => audio.category_name.toLowerCase().includes(e.name_en.toLowerCase())) : true;
        const searchGender = (this.gender.length) ? this.gender.some(e => e.id == parseInt(audio.gender)) : true;
        const searchAgeRange = (this.age_range_str.length) ? this.age_range_str.some(e => audio.age_range_str.split(',').indexOf(e.id) !== -1) : true;
        const searchCountry = (this.country_id.length) ? this.country_id.some(e => e.id == parseInt(audio.country_id)) : true;
        const searchCity = (this.city_str.length) ? this.city_str.some(e => audio.city_str.toLowerCase().includes(e.name.toLowerCase())) : true;
        const searchEthnicity = (this.ethnicity_str.length && audio.ethnicity_str !== null) ? this.ethnicity_str.some(e => audio.ethnicity_str.toLowerCase().includes(e.name.toLowerCase())) : true;
        const searchUnionStatus = (this.union_status_str.length) ? this.union_status_str.some(e => audio.union_status_str.toLowerCase().includes(e.name.toLowerCase())) : true;
        const searchLanguage = (this.language_str.length) ? this.language_str.some(e => audio.language_str.split(',').indexOf(e.name) !== -1) : true;
        return searchName && searchLastname && searchCategory && searchGender && searchAgeRange && searchCountry && searchCity && searchEthnicity && searchUnionStatus && searchLanguage;
      })
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
/* #main { background-color:#aa4d8e !important; } */
#main {
  background-color: #894073 !important;
}

#detail {
  padding: 50px;
}

#centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff !important;
}

@media (max-width: 600px) {
  #detail {
    padding: 25px;
  }

  #centered {
    font-size: 18px;
  }
}
</style>
